import { useEffect, useCallback } from 'react';
import { authService } from '../services/authService';

const DEFAULT_TIMEOUT = 30 * 60 * 1000; // 30 minutes

export const useSessionTimeout = (timeoutMs: number = DEFAULT_TIMEOUT) => {
    const logout = useCallback(() => {
        authService.logout();
        window.location.href = '/login';
    }, []);

    useEffect(() => {
        let timeoutId: NodeJS.Timeout;

        const resetTimer = () => {
            if (timeoutId) clearTimeout(timeoutId);
            timeoutId = setTimeout(logout, timeoutMs);
        };

        const events = ['mousedown', 'keydown', 'scroll', 'touchstart'];

        events.forEach(event => {
            window.addEventListener(event, resetTimer);
        });

        resetTimer(); // Initialize timer

        return () => {
            if (timeoutId) clearTimeout(timeoutId);
            events.forEach(event => {
                window.removeEventListener(event, resetTimer);
            });
        };
    }, [logout, timeoutMs]);
};
